import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import messages from '@/plugins/translator/translations';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';
import './styles/app.scss';
import api from '@/plugins/api/api';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import '@/plugins/veeValidate';

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('locale') ?? 'en',
    messages
});

const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi
        }
    },
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#008489',
                    secondary: '#282828',
                    classic: '#2494F2',
                    danger: '#dc3545'
                }
            }
        }
    }
});

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(i18n);
app.use(vuetify);
app.use(pinia);
app.use(router);
app.use(api);
app.use(VueReCaptcha, {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        useRecaptchaNet: true
    }
});
app.provide('backendApi', app.config.globalProperties.backendApi);
app.mount('#app');
